module.exports = __webpack_public_path__ + "img/weather23.703d9436.png";